import React from 'react';
import axios from 'axios';
import Head from 'next/head';
import ModalR from 'react-responsive-modal';
import { withRouter } from 'next/router';
import {
    NSBreadcrumb, NSContext, NSDrawStars, NSToast, componentLoader, CartLib, getLangPrefix, incrementQty, decrementQty, jwtManager, imgDefaultBase64
} from 'aqlrc';
import Lightbox from 'lightbox-react';
import getAPIUrl from '../lib/getAPIUrl';
import { formatPrice } from '../lib/utils';
import { withI18next } from '../lib/withI18n';
import Layout from '../components/Layout';
import CMS from '../components/CMS';
import routes, { Link, Router } from '../routes';
import Error from './_error';

class PageProduct extends React.Component {
    static getInitialProps = async function (ctx) {
        const { lang } = ctx.nsGlobals;
        const slug  = ctx.query.product;
        const res = await axios.post(`${getAPIUrl(ctx)}v2/products`, {
            lang,
            PostBody : {
                filter : {
                    [`translation.${lang}.slug`] : slug
                },
                structure : {
                    code            : 1,
                    trademark       : 1,
                    id              : 1,
                    translation     : 1,
                    attributes      : 1,
                    code_ean        : 1,
                    pictos          : 1,
                    reviews         : 1,
                    bundle_sections : 1,
                    canonical       : 1,
                    associated_prds : 1
                },
                populate : ['associated_prds', 'bundle_sections.products.id']
            },
            countviews : true
        });
        if (res.data.count === 0) {
            return { notFound: true };
        }

        const taxDisplay = jwtManager.getTaxDisplay(ctx); // TTC / HT


        const slugs      = ctx.query._slug.split('/');
        const promises   = [];
        const categories = [];
        for (let i = 0; i < slugs.length; i++) {
            if (slugs[i] * 1 == slugs[i]) continue;
            if (slugs[i] === 'other') continue;
            promises.push(axios.post(`${getAPIUrl(ctx)}v2/categories`, {
                lang,
                PostBody : {
                    limit  : 1,
                    filter : {
                        [`translation.${lang}.slug`] : slugs[i]
                    },
                    structure : {
                        filters      : 1,
                        children     : 1,
                        colorName    : 1,
                        productsList : 1
                    },
                    populate : ['children']
                }
            }));
        }

        const resCategories = await axios.all(promises);
        for (let i = 0; i < resCategories.length; i++) {
            if (resCategories[i].data.datas[0]) {
                categories.push(resCategories[i].data.datas[0]);
            }
        }

        if (!categories.length) {
            return { notFound: true };
        }

        let datasComponentsCategory = null;
        if (categories.length > 0) {
            if (categories[0] && categories[0].extraText && categories[0].extraText !== '') {
                datasComponentsCategory = {
                    nsCms_extraText : { content: categories[0].extraText }
                };
                datasComponentsCategory = await componentLoader(
                    { content: categories[0].extraText },
                    datasComponentsCategory,
                    getAPIUrl(ctx),
                    lang
                );
            }
        }

        const category = categories[categories.length - 1];
        if (category && category.extraText && category.extraText !== '') {
            datasComponentsCategory = {
                nsCms_extraText : { content: category.extraText }
            };
            datasComponentsCategory = await componentLoader(
                { content: category.extraText },
                datasComponentsCategory,
                getAPIUrl(ctx),
                lang
            );
        }

        let filters = {};
        if (typeof window !== 'undefined') {
            const obj = JSON.parse(window.localStorage.getItem('filters'));
            if (obj && obj.filters) {
                filters = obj.filters;
            }
        }

        return {
            ...datasComponentsCategory,
            product              : res.data.datas[0],
            taxDisplay,
            categories,
            category,
            filters,
            query                : ctx.query,
            allCommentsDisplayed : false,
            slugs
        };
    };

    constructor(props, context) {
        super(props, context);
        const noteQuestions = [];
        if (props.product && props.product.reviews && props.product.reviews.questions) {
            props.product.reviews.questions.forEach((question) => {
                noteQuestions.push({ rate: 0, question: question.question, idQuestion: question.idQuestion });
            });
        }
        if (props.product && props.product.reviews && props.product.reviews.datas && props.product.reviews.datas.length > 1) {
            // On trie les reviews par date de publication
            props.product.reviews.datas.sort((a, b) => new Date(b.review_date) - new Date(a.review_date));
        }
        // Création de ref pour les champs de la modal review et title
        this.title = React.createRef();
        this.review = React.createRef();
        this.limitComment = 2;
        this.maxCharTitle = 50;
        this.maxCharComment = 120;
        this.state        = {
            ...props,
            compositionMenu : {
                cartId : '',
                item   : {
                    _id        : props.product ? props.product._id : '',
                    id         : props.product ? props.product._id : '',
                    quantity   : 1,
                    selections : []
                }
            },
            openModal           : false,
            openComment         : false,
            indexComment        : 0,
            hideReviewsLanguage : false,
            openReviews         : {},
            selectedQty         : 1,
            tab                 : 0,
            isOpen              : false,
            photoIndex          : 0,
            modalComment        : {
                rate : 0,
                noteQuestions
            },
            cmsLegalTxt : {
                content : null
            },
            checkedArray : [],
            search       : ''
        };
        this.formMenu = {};
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return { ...nextProps };
    }

    componentDidMount = async () => {
        const { category } = this.props;
        const { lang, product } = this.state;
        window.localStorage.removeItem('filters');
        if (!product) return;
        const res = await axios.post(`${getAPIUrl()}v2/products`, {
            lang,
            PostBody : {
                filter    : { _id: product._id },
                structure : {
                    code            : 1,
                    trademark       : 1,
                    id              : 1,
                    translation     : 1,
                    attributes      : 1,
                    code_ean        : 1,
                    pictos          : 1,
                    reviews         : 1,
                    bundle_sections : 1,
                    stock           : 1,
                    canonical       : 1,
                    associated_prds : 1
                },
                populate : ['associated_prds', 'bundle_sections.products.id']
            }
        });
        if (res.data && res.data.datas && res.data.datas.length) {
            this.setState({ product: res.data.datas[0] });
        }
        // selection du tab par defaut
        if (typeof window !== 'undefined' && window.location.hash !== '') {
            if (window.location.hash === '#reviews') {
                this.goTo('reviews');
                return;
            }
            this.goTo('infos');
            if (window.location.hash === '#tab-characteristics' && this.state.tab !== 1) {
                this.setState({ tab: 1 });
            }
        }

        const obj = JSON.parse(window.localStorage.getItem('filters'));
        if (obj) {
            this.setState({
                filters      : obj.category === category.name && obj.filters ? obj.filters : {},
                checkedArray : obj.category === category.name ? obj.checkedArray : [],
                search       : obj.category === category.name && obj.filters && obj.filters.$text ? obj.filters.$text.$search : ''
            });
        }
    }

    onLangChange = async (lang) => {
        window.location.pathname = `${await getLangPrefix(lang)}/${this.props.category.slug[lang]}/${this.props.product.slug[lang]}`;
    };

    handleSearch = (search) => {
        this.setState({ search });
    };

    search = (e) => {
        e.preventDefault();
        const { category, slugs, routerLang } = this.props;
        const { checkedArray, filters, search } = this.state;
        if (search !== '') {
            filters.$text = { $search: search };
        } else {
            delete filters.$text;
        }
        let local_filters = JSON.parse(window.localStorage.getItem('filters'));
        if (local_filters) {
            local_filters.filters = filters;
        } else {
            local_filters = { category: category.name, filters, checkedArray };
        }
        window.localStorage.setItem('filters', JSON.stringify(local_filters));
        this.setState({ filters }, () => {
            Router.pushRoute('categoryI18n', { lang: routerLang, _slug: slugs }).then(() => window.scrollTo({ left: 0, top: document.querySelector('.section--sidebar').offsetTop, behavior: 'smooth' }));
            // window.location.pathname = `${urlLang}/c/${slugs.join('/')}`;
        });
    }

    onOpenModal = () => {
        this.setState({ openModal: true });
    };

    onCloseModal = () => {
        this.setState({ openModal: false });
    };

    onOpenModalComment = async () => {
        try {
            // On recupére le blockCMS legalText
            const { cmsLegalTxt } = this.state;
            if (cmsLegalTxt.content === null) {
                const resCmsLegalTxt = await axios.post(`${getAPIUrl()}v2/component/ns-cms/legalTxt`, { lang: this.props.lng });
                if (resCmsLegalTxt && resCmsLegalTxt.data && resCmsLegalTxt.data.content) {
                    cmsLegalTxt.content = resCmsLegalTxt.data.content;
                }
            }
            this.setState({ openComment: true, cmsLegalTxt });
        } catch (error) {
            console.error(error);
            this.setState({ openComment: true });
        }
    };

    onCloseModalComment = () => {
        this.setState({ openComment: false });
    };

    onSuccessComment = async (e) => {
        try {
            e.preventDefault();
            const { lang } = this.props;
            const { modalComment, product } = this.state;
            let rate = 0;
            const questions = [];
            if (modalComment.noteQuestions && modalComment.noteQuestions.length) {
                const foundNotRated = modalComment.noteQuestions.find((question) => question.rate === 0);
                if (foundNotRated) {
                    return NSToast.warn('product:note_features_required');
                }
                rate = modalComment.rate;
                modalComment.noteQuestions.forEach((question) => {
                    questions.push({ rate: question.rate, question: question.question, idQuestion: question.idQuestion });
                });
            } else {
                if (!modalComment.rate) {
                    return NSToast.warn('product:note_required');
                }
                rate = modalComment.rate;
            }
            const review = this.review.current.value;
            const title = this.title.current.value;
            await axios.put(`${getAPIUrl()}v2/product/${product._id}/review`, {
                review, title, rate, lang, questions
            });
            this.setState({ openComment: false });
            return NSToast.success('product:review_successfully_sent');
        } catch (error) {
            console.error(error);
            // NSToast.error(error.response);
        }
    };

    _decrementQty = (e) => {
        decrementQty(this, e);
    };

    _incrementQty = (e) => {
        incrementQty(this, e);
    };

    createMenuSection = (section, inputs) => {
        if (inputs.length === undefined || inputs.type === 'select-one') {
            if ((inputs.type === 'radio' && inputs.checked === true) || (inputs.type === 'select-one' && inputs.value && inputs.value !== '')) { return { bundle_section_ref: section.ref, products: [inputs.value] }; }
            if (section.isRequired && ((inputs.type === 'radio' && inputs.checked === false) || (inputs.type === 'select-one' && inputs.value === ''))) { throw `Veuillez sélectionner au moins 1 ${section.ref}`; }
        }

        const checkedInputs = [];
        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].checked === true) { checkedInputs.push(inputs[i]); }
        }
        if (section.isRequired && checkedInputs.length === 0) {
            throw `Veuillez sélectionner au moins 1 ${section.ref.toLowerCase()}`;
        }
        const values = [];
        for (let i = 0; i < checkedInputs.length; i++) {
            values.push(checkedInputs[i].value);
        }
        if (values.length < section.minSelect) {
            throw `Vous devez sélectionner au moins ${section.minSelect} ${section.ref.toLowerCase()}${section.minSelect > 1 ? 's' : null}`;
        }
        if (values.length > section.maxSelect) {
            throw `Vous ne pouvez sélectionner plus de ${section.maxSelect} ${section.ref.toLowerCase()}${section.maxSelect > 1 ? 's' : null}`;
        }
        return { bundle_section_ref: section.ref, products: values };
    }

    addToCart = async () => {
        try {
            const { lang } = this.props;
            const { product, selectedQty } = this.state;
            if (product.type === 'bundle') {
                const { compositionMenu } = this.state;
                this.setState({ openModal: true }, () => {
                    try {
                        for (let i = 0; i < product.bundle_sections.length; i++) {
                            const cm = this.createMenuSection(product.bundle_sections[i], this.formMenu[product.bundle_sections[i].ref]);
                            if (cm.products.length > 0) { compositionMenu.item.selections.push(cm); }
                        }
                    } catch (e) {
                        console.error(e);
                        NSToast.warn(e);
                        this.setState({
                            compositionMenu : {
                                cartId : '',
                                item   : {
                                    _id        : this.props.product._id,
                                    id         : this.props.product._id,
                                    quantity   : 1,
                                    selections : []
                                }
                            }
                        });
                        return;
                    }
                    compositionMenu.cartId = window.localStorage.getItem('cart_id');
                    CartLib.addToCartBundleProduct(compositionMenu, (cart) => {
                        NSToast.success('product-card:product_added');
                        window.localStorage.setItem('cart_id', cart._id);
                        const event = new CustomEvent('updateCart', { detail: { cart } });
                        window.dispatchEvent(event);
                        this.setState({ openModal: false });
                    }, (err) => {
                        console.error(err.response.data.message);
                    });
                });
            } else {
                CartLib.addToCart(product, selectedQty, (cart) => {
                    window.localStorage.setItem('cart_id', cart._id);
                    NSToast.success('product-card:product_added');
                    const event = new CustomEvent('updateCart', { detail: { cart } });
                    window.dispatchEvent(event);
                    this.setState({ openModal: true });
                }, (err) => {
                    console.error(err.response.data.message);
                });
            }
            this.setState({
                compositionMenu : {
                    cartId : '',
                    item   : {
                        _id        : this.props.product._id,
                        id         : this.props.product._id,
                        quantity   : 1,
                        selections : []
                    }
                }
            });
        } catch (e) {
            console.error(e);
            window.localStorage.removeItem('cart_id');
            NSToast.error('common:error_occured');
        }
    };

    downloadVirtual = async () => {
        const { routerLang, user } = this.props;
        if (!user) {
            return Router.pushRoute('auth', { lang: routerLang }).then(() => NSToast.warn('product:notConnectedDownload'));
        }
        const { product } = this.state;
        axios({
            url          : `${getAPIUrl()}v2/product/download?p_id=${product._id}`,
            method       : 'GET',
            responseType : 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${product.code}.zip`);
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            const b = new Blob([error.response.data]);
            const fr = new FileReader();
            fr.onload = function () {
                const result = JSON.parse(this.result);
                return NSToast.error(result.message);
            };
            fr.readAsText(b);
        });
    }

    goToContact = () => {
        window.open('https://www.aquila-cms.com/contactez-nous', '_blank');
    }

    toggleOpenReview = (index) => {
        const { openReviews } = this.state;
        if (!openReviews[index]) {
            openReviews[index] = true;
        } else {
            openReviews[index] = false;
        }
        return this.setState({ openReviews });
    };

    changeTabState = (value) => {
        this.setState({
            tabState : value
        });
    };

    prevComments = () => {
        let { indexComment } = this.state;
        const { datas } = this.state.product.reviews || [];
        indexComment -= this.limitComment;
        if (indexComment < 0) {
            if (indexComment % 2) indexComment = datas.length - 2;
            else indexComment = datas.length - 1;
        }
        const displayedComments = datas.slice(indexComment, indexComment + this.limitComment);
        this.setState({ displayedComments, indexComment });
    };

    nextComments = () => {
        let { indexComment } = this.state;
        const { datas } = this.state.product.reviews || [];
        indexComment += this.limitComment;
        if (indexComment >= datas.length) indexComment = 0;
        const displayedComments = datas.slice(indexComment, indexComment + this.limitComment);
        this.setState({ displayedComments, indexComment });
    };

    toggleAllComment = (e) => {
        const { allCommentsDisplayed, hideReviewsLanguage } = this.state;
        this.setState({ allCommentsDisplayed: !allCommentsDisplayed, hideReviewsLanguage: !hideReviewsLanguage });
    }

    /**
     * Permet de recupérer la note de la question
     */
    onClickSelectNote = (oStar) => {
        const { modalComment } = this.state;
        // Si des questions existent
        if (modalComment.noteQuestions && modalComment.noteQuestions.length) {
            // On assigne la note a la question qui vient d'être noté
            const i = modalComment.noteQuestions.findIndex((question) => question.idQuestion === oStar.idQuestion);
            if (i === -1) return;
            modalComment.noteQuestions[i].rate = oStar.note;
            // Calcul de la note moyenne des questions
            let sum = 0;
            modalComment.noteQuestions.forEach((question) => sum += question.rate);
            if (sum === 0) return;
            const rate = (sum / modalComment.noteQuestions.length);
            modalComment.rate = Math.round(rate.toFixed(1));
            return this.setState({ modalComment });
        }
        // On changera uniquement la note global
        modalComment.rate = oStar.note;
        this.setState({ modalComment });
    };

    goTo = (id) => {
        const elt = document.getElementById(id);
        if (!elt) return;
        elt.scrollIntoView();
    };

    openLightBox(i) {
        this.setState({ photoIndex: i, isOpen: true });
    }

    render = () => {
        const {
            appurl, category, isEmpty, lang, notFound, oCmsHeader, oCmsFooter, routerLang, sitename, t
        } = this.props;
        if (notFound || isEmpty) {
            return (
                <NSContext.Provider value={{ props: this.props, state: this.state, onLangChange: (l) => this.onLangChange(l) }}>
                    <Error statusCode={404} message="Not found" oCmsHeader={oCmsHeader} oCmsFooter={oCmsFooter} />);
                </NSContext.Provider>
            );
        }
        const {
            isOpen, openModal, openComment, modalComment, openReviews, photoIndex, product, allCommentsDisplayed, hideReviewsLanguage, taxDisplay, search
        } = this.state;
        const canonical = product.canonical ? `${appurl}${product.canonical.substr(1)}` : '';
        const imgStar = '/static/images/sprite/ico-star-full@2x.png';
        // Chemin de l'image non trouvé
        const imgDefault = { url: imgDefaultBase64, alt: 'illustration produit' };
        if (product && product.images && product.images.length) {
            const foundImg = product.images.find((img) => img.default);
            if (foundImg) {
                imgDefault.url = foundImg._id !== 'undefined' ? `/images/products/${category.code === 'themes' ? '536x860' : '536x335'}-100/${foundImg._id}/${product.slug[lang]}${foundImg.extension}` : imgDefault.url;
                imgDefault.alt = foundImg.alt || imgDefault.alt;
            } else {
                imgDefault.url = product.images[0]._id !== 'undefined' ? `/images/products/${category.code === 'themes' ? '536x860' : '536x335'}-100/${product.images[0]._id}/${product.slug[lang]}${foundImg.extension}` : imgDefault.url;
                imgDefault.alt = product.images[0].alt || imgDefault.alt;
            }
        }

        const attributes = product.attributes.filter((a) => a.value && a.value.length);

        // Pictos
        const pictos = [];
        if (product.pictos) {
            product.pictos.forEach((picto) => {
                if (pictos.find((p) => p.location === picto.location) !== undefined) {
                    pictos.find((p) => p.location === picto.location).pictos.push(picto);
                } else {
                    const cardinals = picto.location.split('_');
                    const style = { top: 0, left: 0 };
                    if (cardinals.includes('RIGHT')) {
                        style.left = 'inherit';
                        style.right = 0;
                    }
                    if (cardinals.includes('BOTTOM')) {
                        style.top = 'inherit';
                        style.bottom = 0;
                    }
                    if (cardinals.includes('CENTER')) {
                        style.left = '50%';
                        style.transform = 'translate(-50%, 0)';
                    }
                    if (cardinals.includes('MIDDLE')) {
                        style.top = '50%';
                        style.transform = 'translate(0, -50%)';
                    }
                    pictos.push({ location: picto.location, style, pictos: [picto] });
                }
            });
        }

        const price = product.price.et.special >= 0 ? product.price.et.special : product.price.et.normal;

        return (
            <NSContext.Provider value={{ props: this.props, state: this.state, onLangChange: (l) => this.onLangChange(l) }}>
                <Layout header={oCmsHeader.content} footer={oCmsFooter.content}>
                    <Head>
                        <title>{sitename} | {product.name !== undefined && product.name !== '' ? product.name : ''}</title>
                        {
                            product.description2 && product.description2.text ? <meta name="description" content={product.description2.title} /> : null
                        }
                        <link rel="canonical" href={canonical} />
                        <meta property="og:title" content={`${sitename} | ${product.name !== undefined && product.name !== '' ? product.name : ''}`} />
                        <meta property="og:url" content={canonical} />
                        <meta property="og:type" content="article" />
                        <meta property="og:image" content={`${appurl}${imgDefault.url}`} />
                    </Head>
                    <div className="main">
                        <div className="intro intro--alt color-white text-center">
                            <div className="decoration-arrow color-white">
                                <div className="decoration__img decoration__img--3">
                                    <img src="/images/medias/1504x1003/5e53d6c8664f2a3aa0e47d95/notebook@2x.jpg" alt="" />
                                </div>{/* <!-- /.decoration__img --> */}
                            </div>{/* <!-- /.decoration-arrow --> */}

                            <div className="intro__inner">
                                <div className="shell">
                                    <div className="title_intro">{category.name}</div>

                                    <div className="form form--search color-gray">
                                        <form onSubmit={this.search}>
                                            <div className="form__controls form__controls--search bg-white">
                                                <label htmlFor="field-search" className="hidden">Search</label>

                                                <input type="text" id="field-search" className="field" value={search} placeholder={t('product:search')} onChange={(e) => this.handleSearch(e.target.value)} />

                                                <button type="button" className="form__icon" onClick={this.search}>
                                                    <i className="ico-search" />{/* <!-/.ico-search --> */}
                                                </button>{/* <!-/.form__icon --> */}
                                            </div>{/* <!-/.form__controls --> */}
                                        </form>
                                    </div>{/* <!-/.form --> */}
                                </div>{/* <!-/.shell --> */}
                            </div>{/* <!-/.intro__inner --> */}
                        </div>{/* <!-- /.intro --> */}

                        <div className="section section--intro">
                            <div className="section__inner">
                                <div className="shell">
                                    <NSBreadcrumb gNext={{ routes, Link }} />
                                    <div className="promo-container">
                                        <div className="article article--clic">
                                            {product.is_new && <h6>{t('product:new')}</h6>}

                                            {
                                                // product.reviews.reviews_nb > 0 && (
                                                //     <div className="rating">
                                                //         <div className="stars">
                                                //             {
                                                //                 [...Array(5)].map((el, idx) => (
                                                //                     <div key={idx} className="star" style={{ width: '13px' }}>
                                                //                         <i className="ico-star" style={idx < Math.round(product.reviews.average) ? null : { filter: 'grayscale(100%)' }} />
                                                //                     </div>/* <!-- /.star --> */
                                                //                 ))
                                                //             }
                                                //         </div>{/* <!-- /.stars --> */}

                                                //         <div className="rating__content">
                                                //         ({product.reviews.reviews_nb})
                                                //         </div>{/* <!-- /.rating__content --> */}

                                                //         <a href="#" className="rating__link" />
                                                //     </div>/* <!-- /.rating --> */
                                                // )
                                            }

                                            <h1>{product.name}</h1>

                                            <div className="article__info">
                                                {attributes && attributes.find((a) => a.code === 'developper') && attributes.find((a) => a.code === 'developper').value && <h3>{t('product:developed')} {attributes.find((a) => a.code === 'developper').value}</h3>}

                                                {attributes && attributes.find((a) => a.code === 'skill') && attributes.find((a) => a.code === 'skill').value && <h3>{t('product:level')} : {attributes.find((a) => a.code === 'skill').value}</h3>}
                                            </div>{/* <!-- /.article__info --> */}

                                            <div className="product__images">
                                                <figure
                                                    className="product__image" style={{ cursor: product.images.length ? 'pointer' : 'unset' }}
                                                    onClick={() => (product.images.length ? this.openLightBox(product.images.findIndex((img) => img.default)) : false)}
                                                >
                                                    <img itemProp="image" src={imgDefault.url} alt={imgDefault.alt} />
                                                </figure>
                                                {
                                                    isOpen && (
                                                        <Lightbox
                                                            mainSrc={`/images/products/max-100/${product.images[photoIndex]._id}/${product.slug[lang]}${product.images[photoIndex].extension}`}
                                                            nextSrc={`/images/products/max-100/${product.images[(photoIndex + 1) % product.images.length]._id}/${product.slug[lang]}${product.images[(photoIndex + 1) % product.images.length].extension}`}
                                                            prevSrc={`/images/products/max-100/${product.images[(photoIndex + product.images.length - 1) % product.images.length]._id}/${product.slug[lang]}${product.images[(photoIndex + product.images.length - 1) % product.images.length].extension}`}
                                                            imageTitle={product.images[photoIndex].alt}
                                                            onCloseRequest={() => this.setState({ isOpen: false })}
                                                            onMovePrevRequest={() => this.setState({ photoIndex: (photoIndex + product.images.length - 1) % product.images.length })}
                                                            onMoveNextRequest={() => this.setState({ photoIndex: (photoIndex + 1) % product.images.length })}
                                                        />
                                                    )
                                                }
                                                <ul className="list-images">
                                                    {
                                                        product.images && product.images.filter((img) => !img.default) ? product.images.filter((img) => !img.default).map((img, index) => (
                                                            <li key={img.url}>
                                                                <a onClick={() => this.openLightBox(product.images.findIndex((im) => im._id === img._id))}>
                                                                    <img
                                                                        itemProp="image"
                                                                        src={`/images/products/82x82-100/${img._id}/${product.slug[lang]}-${index}${img.extension}`}
                                                                        alt={img.alt}
                                                                    />
                                                                </a>
                                                            </li>
                                                        )) : ''
                                                    }
                                                </ul>
                                            </div>
                                        </div>{/* <!-- /.article --> */}

                                        <div className="promo">
                                            <div className="promo__inner">
                                                {
                                                    product.price.et.special >= 0 && (
                                                        <div className="h3">
                                                            <del>{formatPrice(product.price.et.normal)}<span> {t('product:et')}</span></del>
                                                        </div>
                                                    )
                                                }
                                                <div className="h2">
                                                    {
                                                        price > 0 ? (
                                                            <>{formatPrice(price)}<span> {t('product:et')}</span></>
                                                        ) : (
                                                            category.code === 'modules' || category.code === 'themes' ? t('product:free') : null
                                                        )
                                                    }
                                                </div>

                                                {/* <h3>{product.price.ati.special >= 0 ? product.price.ati.special.toFixed(2) : product.price.ati.normal.toFixed(2)}<span> &euro; {t('product:ati')}</span></h3> */}

                                                {
                                                    product.type === 'virtual' && price === 0 ? (
                                                        category.code === 'modules' || category.code === 'themes' ? (
                                                            <>
                                                                <p>{product.downloadInfos}</p>
                                                                <br />
                                                                <button type="button" className="btn" onClick={this.downloadVirtual}>
                                                                    <span className="btn__content color-orange">{t('product:download')}</span>
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <button type="button" className="btn bg-white" onClick={this.goToContact}>
                                                                <span className="btn__content color-orange">{t('product:contact')}</span>
                                                            </button>
                                                        )
                                                    ) : (
                                                        <button type="button" className="btn bg-white" onClick={this.addToCart}>
                                                            <span className="btn__content color-orange">{t('product:addToCart')}</span>
                                                        </button>
                                                    )
                                                }

                                                {
                                                    (category.code !== 'themes') && (
                                                        <div className="article-alt">
                                                            <h2>{t('product:advantages')}</h2>

                                                            {/* {product.description2 && product.description2.text && <p dangerouslySetInnerHTML={{ __html: product.description2.text }} />} */}
                                                            {product.description2 && product.description2.text && <p><CMS content={product.description2.text } /></p>}
                                                        </div>/* <!-- /.article-alt --> */
                                                    )
                                                }
                                            </div>{/* <!-- /.promo__inner --> */}
                                            {
                                                category.code === 'themes' && (
                                                    <div className="promo__actions">
                                                        <a href={product.description1 && product.description1.title ? product.description1.title : '#'} target="_blank" className="btn btn--orange">{t('product:demo')}</a>
                                                    </div>/* <!-- /.promo__actions --> */
                                                )
                                            }
                                            {category.code === 'themes' && product.description2 && product.description2.text && <div className="articles" dangerouslySetInnerHTML={{ __html: product.description2.text }} />/* <!-- /.articles --> */}
                                        </div>{/* <!-- /.promo --> */}
                                    </div>{/* <!-- /.promo-container --> */}

                                    {
                                        product.description1 && product.description1.text && (
                                            <div className="articles">
                                                <div className="article-alt">
                                                    <h2>Description</h2>
                                                    <div dangerouslySetInnerHTML={{ __html: product.description1.text }} />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>{/* <!-- /.shell --> */}
                            </div>{/* <!-- /.section__inner --> */}
                        </div>{/* <!-- /.section --> */}

                        <div className="section section--lists" hidden={!attributes.length}>
                            <div className="decoration decoration--alt color-graylight op-2" />{/* <!-- /.decoration --> */}

                            <div className="section__inner">
                                <div className="shell">
                                    <div className="article-alt">
                                        <h2>{t('product:features')}</h2>
                                    </div>{/* <!-- /.article-alt --> */}

                                    <div className="section__cols">
                                        <div className="section__col">
                                            <ul className="list-check">
                                                {
                                                    attributes && attributes.map((attr) => {
                                                        if (attr.type === 'color') {
                                                            return (
                                                                <li key={attr._id}>
                                                                    <i className="ico-check list__icon" />

                                                                    {attr.name} : <span style={{
                                                                        marginLeft : '5px', padding : '0 10px', backgroundColor : attr.value.toString(), borderRadius : '5px'
                                                                    }}
                                                                    />
                                                                </li>
                                                            );
                                                        }
                                                        return (
                                                            <li key={attr._id}>
                                                                <i className="ico-check list__icon" />

                                                                {attr.name} : {Array.isArray(attr.value) ? attr.value.join(', ') : attr.value}
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>{/* <!-- /.list-check --> */}
                                        </div>{/* <!-- /.section__col --> */}
                                    </div>{/* <!-- /.section__cols --> */}
                                </div>{/* <!-- /.shell --> */}
                            </div>{/* <!-- /.section__inner --> */}
                        </div>{/* <!-- /.section --> */}

                        {/*
                    <div className="section section--quotes">
                        <div className="decoration decoration--rev color-white" />

                        <div className="section__inner">
                            <div className="shell">
                                <div className="article-alt">
                                    <h2>{t('product:reviews')}</h2>

                                    <blockquote>
                                        &ldquo;Le meilleur développeur sur addons prestashop , rapidité , professionalisme et sympathique thème de très bonne qualité je recommande!!!&rdquo; <span>Mickael F. - 09/08/2018</span>
                                    </blockquote>

                                    <blockquote>
                                        &ldquo;Le meilleur développeur sur addons prestashop , rapidité , professionalisme et sympathique thème de très bonne qualité je recommande!!!&rdquo; <span>Mickael F. - 09/08/2018</span>
                                    </blockquote>

                                    <blockquote>
                                        &ldquo;Le meilleur développeur sur addons prestashop , rapidité , professionalisme et sympathique thème de très bonne qualité je recommande!!!&rdquo; <span>Mickael F. - 09/08/2018</span>
                                    </blockquote>

                                    <blockquote>
                                        &ldquo;Le meilleur développeur sur addons prestashop , rapidité , professionalisme et sympathique thème de très bonne qualité je recommande!!!&rdquo; <span>Mickael F. - 09/08/2018</span>
                                    </blockquote>

                                    <div className="article__actions text-center">
                                        <button type="button" className="btn btn--orange" onClick={this.onOpenModalComment}>
                                            {t('product:postReview')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    */}
                    </div>{/* <!-- /.main --> */}
                    <ModalR
                        animationDuration={0} classNames={{ modal: 'popup__container', overlay: 'popup active' }}
                        open={openModal} onClose={this.onCloseModal} center
                    >
                        <h3 className="popup__title">{t('product:productAdded')} :</h3>
                        <div className="popup__body">
                            <div className="product-simple">
                                <figure className="product__image">
                                    <img src={imgDefault.url} alt={imgDefault.alt} />
                                </figure>

                                <h4 className="product__title">{this.state.selectedQty} x {product.name}</h4>

                                <div className="product__actions" style={{ marginTop: '20px', textAlign: 'center' }}>
                                    <button type="button" className="btn btn--color color-purple" onClick={this.onCloseModal}>
                                        <span className="btn__content">{t('product:continueShopping')}</span>
                                    </button>

                                    <Link route="cart" params={{ lang: routerLang }}>
                                        <a className="btn btn--color color-purple" style={{ marginLeft: '10px' }}>
                                            <span className="btn__content">{t('product:viewCart')}</span>
                                        </a>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </ModalR>
                    <ModalR open={openComment} onClose={this.onCloseModalComment} delay={0} center>
                        <div className="modal-wrapper-add-comment is-open" style={{ overflowY: 'auto' }}>
                            <button type="button" className="modal-backdrop nbb" />
                            <div className="modal is-open">
                                <button type="button" className="modal-close nbb">
                                    <i className="ico-close" onClick={this.onCloseModalComment} />
                                </button>
                                <div className="subscribe-modal">
                                    <div>
                                        <p style={{ color: '#4A4A4A', fontSize: '16px', paddingLeft: '20px' }}>
                                            <span style={{ fontWeight: '600', fontSize: '22px' }}>{product.name}</span><br />
                                            {product.description1 && product.description1.title ? product.description1.title : null}
                                        </p>
                                    </div>
                                    <br />
                                    <div className="rating-boxes" style={{ justifyContent: 'space-between', padding: '0 36px 0 36px' }}>
                                        <span style={{ fontSize: '22px', fontWeight: '700' }}>{t('product:overall_rating')}</span>
                                        {
                                        // Si des questions existent alors on ne pourra pas cliquer sur les etoiles de la note globale,
                                        // ce sont le cumule des notes des questions qui définirons la note globale
                                            modalComment.noteQuestions && modalComment.noteQuestions.length > 0
                                                ? (
                                                    <div className="rating-split modify-star">
                                                        <NSDrawStars average={modalComment.rate} size="20" src={imgStar} />
                                                    </div>
                                                ) : (
                                                    <div className="rating-split modify-star">
                                                        <NSDrawStars
                                                            editmode
                                                            average={modalComment.rate}
                                                            size="20"
                                                            idQuestion="global"
                                                            src={imgStar}
                                                            onClickStar={this.onClickSelectNote}
                                                        />
                                                    </div>
                                                )

                                        }
                                    </div>
                                    <form onSubmit={(e) => this.onSuccessComment(e)}>
                                        <div style={{ marginBottom: '18px' }}>
                                            {
                                                modalComment.noteQuestions.length > 0 && modalComment.noteQuestions.map((question) => (
                                                    <div key={question.idQuestion} className="rating-boxes" style={{ justifyContent: 'space-between', padding: '0 36px 0 36px' }}>
                                                        <span style={{ maxWidth: '75%' }}>{question.question}</span>
                                                        <div className="rating-split modify-star">
                                                            <NSDrawStars
                                                                editmode
                                                                average={question.rate}
                                                                size="20"
                                                                idQuestion={question.idQuestion}
                                                                src={imgStar}
                                                                onClickStar={this.onClickSelectNote}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <div className="subscribe__body" style={{ paddingTop: '10px', paddingBottom: '0px' }}>
                                            <label htmlFor="title">{t('product:reviewTitle')}</label>
                                            <input type="text" id="title" name="title" ref={this.title} className="subscribe__field" style={{ height: '40px' }} maxLength="140" required />
                                        </div>
                                        <div className="subscribe__body" style={{ paddingTop: '10px', paddingBottom: '0px' }}>
                                            <label htmlFor="review">{t('product:feedback')}</label>
                                            <textarea type="text" id="review" name="review" ref={this.review} className="subscribe__field" style={{ height: '70px', lineHeight: '27px' }} required />
                                        </div>
                                        <div className="subscribe__body" style={{ paddingTop: '10px', paddingBottom: '0px' }}>
                                            <label htmlFor="surname">{t('product:reviewNickname')}</label>
                                            <input type="text" id="surname" name="surname" className="subscribe__field" required style={{ height: '40px' }} />
                                        </div>
                                        <br />
                                        <div className="subscribe__actions">
                                            <button type="submit" className="subscribe__btn btn btn--grey btn--medium">{t('product:send')}</button>
                                        </div>
                                        <br />
                                        <div>
                                            <div dangerouslySetInnerHTML={{ __html: this.state.cmsLegalTxt.content || '' }} />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </ModalR>
                </Layout>
            </NSContext.Provider>
        );
    }
}

export default withRouter(withI18next(['product'])(PageProduct));
